import { signInWithRedirect } from 'aws-amplify/auth'
// • Triggers sign-in via a configured external Identity Provider (CustomIDP) using Amplify redirect flow
export const useIdp = (): { signInWithIdp: () => Promise<void> } => {
  const signInWithIdp = async (): Promise<void> => {
    try {
      await signInWithRedirect({ provider: { custom: 'CustomIDP' } })
    } catch (error) {
      console.error('Error during IdP sign-in redirect:', error)
    }
  }

  return { signInWithIdp }
}
